import {createSlice} from "@reduxjs/toolkit";

const initialScrimListState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  exportData: [], 
  contestData: [], 
  contestUsers: [], 
  retentionreportlist: [],
 
  gameTypeList: [],
 
  upload: {},
  // hostListList: [],
  // imageField : undefined,
  screenShots: [], 
  totalJoinedPlayers: 0,

  countryDropdownList: [],
  country: [],
  gameList: [],
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const NewGamewisereportSlice = createSlice({
  
  name: "newGamewisereportSlice",
  initialState: initialScrimListState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    clearfetchStaffUsers: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.entities = [];
      state.totalCount = 0;
    },
    emptyList: (state, action) => {
      state.error = null;
      state.entities = [];
      // state.totalCount = 0;
      state.exportData = [];
    },
    
    hostListList: (state, action) => {
      const { totalCount, entities } = action.payload;
      console.log("totalCount, entities slice",totalCount, entities)
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    contestDetails: (state, action) => {
      const { contestData } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.contestData = contestData;
    },
    contestUsersList: (state, action) => {
      const { contestUsers } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.contestUsers = contestUsers;
    },
    CountryDropdownList: (state, action) => {
      const { countryDropdownList } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.totalCount = 0;
      state.countryDropdownList = countryDropdownList;
    },
    gameList: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.gameList = entities;
    },
    gameTypeList: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.gameTypeList = entities;
    },
    company: (state, action) => {
      const { totalCount, entities } = action.payload;
      // console.log(entities)
      state.listLoading = false;
      state.error = null;
      state.company = entities;
      // state.totalCount = totalCount;
  },

      CountryDropdownList: (state, action) => {
      const { countryDropdownList } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.totalCount = 0;
      state.countryDropdownList = countryDropdownList;
    },
  itemUpdated: (state, action) => {
    state.error = null;
    state.actionsLoading = false;
    state.entities = [];
  },
    
    saveScreenShot: (state, action) => {
      const { screenShots } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.screenShots = screenShots;
    },
    saveIsHackingProof: (state, action) => {
      const { isHackingProofImages } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.isHackingProofImages = isHackingProofImages;
    },
    saveTotalJoinedPlayers: (state, action) => {
      const { totalJoinedPlayers } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.totalJoinedPlayers = totalJoinedPlayers;
    }

  }
});


